import { useMemo } from 'react';

import type { TableState } from 'react-table';

import type { BaseRecord } from 'bringg-web/components/bringg-react-table';
import type { TableConfigObjectAdapter } from 'bringg-web/stores/alerts-view/table-config-object-adapter';

const useInitialTableState = <T extends BaseRecord>(tableConfig: TableConfigObjectAdapter) => {
	const { tableSortBy, tableColumnWidths } = tableConfig;

	const initialState: Partial<TableState<T>> = useMemo(
		() => ({
			sortBy: tableSortBy,
			columnResizing: {
				columnWidths: tableColumnWidths,
				columnWidth: 0,
				headerIdWidths: {}
			}
		}),
		// According to logic of INITIAL state deps should be empty
		// all required data must be present in the store on initial render
		[]
	);

	return initialState;
};

export default useInitialTableState;
